import { render, staticRenderFns } from "./QuickSetupProfile.vue?vue&type=template&id=23cf967a&"
import script from "./QuickSetupProfile.vue?vue&type=script&lang=js&"
export * from "./QuickSetupProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports